import { Environment } from '@shared/core';

export const environment: Environment = {
    BUGSNAG_KEY: '',
    RELEASE_STAGE: '',
    production: false,
    STRIPE_PUBLIC_KEY: '',
    // eslint-disable-next-line @typescript-eslint/no-var-requires,@typescript-eslint/no-require-imports
    VERSION: require('../../../../package.json').version,
    inMemory: false,
    api: {
        url: '',
    },
    contenthub: {
        token: '',
        url: '',
    },
    agora: {
        appId: '5904be04ed014eef8ddfdd45c0035e61',
        logLevel: 0,
    },
    eposvet: {
        service: {
            protocol: 'http://',
            rootUrl: '10.230.33.13',
            apiPort: ':9090',
            apiUrl: '/booking/patient/api',
            erpApiUrl: '/booking/erp/api',
            communicationapi: '/booking/erp/communicationapi',
        },
        patient: {
            protocol: 'http://',
            rootUrl: '10.230.33.13',
            port: ':9090',
            url: '/booking/patient/api',
        },
        telemed: {
            protocol: 'http://',
            rootUrl: '10.230.33.13',
            port: ':9090',
            url: '/booking/erp/telemed',
        },
        ePosvet: {
            protocol: 'http://',
            rootUrl: '10.230.33.13',
            port: ':9090',
            url: '/booking/erp/eposvet',
        },
        agora: {
            appId: 'cc7bce7c08c44569b7f8a88ecf3dfd24',
            logLevel: 0,
            proxyServer: 'eposvet-proxy.eambulanta.si',
            turnServer: {
                turnServerURL: '18.184.90.216',
                username: 'medifit',
                password: '123krneki567',
                udpport: 3478,
                tcpport: 3478,
                forceturn: false,
            },
        },
        webSocketTelemed: {
            protocol: 'ws://',
            rootUrl: '10.230.33.13',
            port: ':8888',
            url: '/booking/ws/telemed/',
        },
        document: {
            protocol: 'http://',
            rootUrl: '10.230.33.13',
            port: ':9090',
            url: '/booking/eav2/erp/docapi',
        },
    },
    reCaptcha: {
        v2: {
            siteKey: '',
            siteId: '',
        },
        v3: {
            siteKey: '',
            siteId: '',
        },
    },
};
